App.ErrorController = Em.Controller.extend
  env: Em.inject.service('environment')
  inappSupport: Em.inject.service()

  supportLink: (->
    "mailto:#{@get('env.supportEmail')}"
  ).property('env.supportEmail')

  actions:
    support: ->
      # todo i18n
      @get('inappSupport').initiateDialogue("""
        Опишите проблему:

        ####
        ## Пожалуйста, не удаляйте эти строки. Они помогут нам быстрее разобраться,
        ## в чем была проблема.
        ####

        #{@get('error').stack}
      """)
      false
